/* eslint-disable max-len */
const localizationPL = {
  addUser: 'Dodaj użytkownika',
  answersWeightManagerTitle: 'Odpowiedzi',
  activeNameForm: 'Nazwa aktywnego formularza',
  confirmation: 'Zatwierdź zmiany',
  content: 'Zawartość',
  copied: 'Skopiowano',
  copyIcon: 'Skopiuj link',
  countAnswers: 'Ilość odpowiedzi',
  createBy: 'Stworzono przez ',
  creator: 'Twórca',
  dashboard: 'Pulpit',
  dataSave: 'Dane zostały zapisane',
  draw: 'Losowanie',
  drawAnswers: 'Wylosuj odpowiedzi',
  dropzoneDropFile: 'Tu upuść plik',
  dropzoneOnlyCSV: 'Tylko pliki z rozszerzeniem CSV',
  dropzoneSelectFile: 'Upuść tu plik lub kliknij, aby wybrać z listy',
  duplicatedApp: 'Taka instancja tymczasowej aplikacji już istnieje. Proszę zamknij ją.',
  email: 'E-mail',
  emailAddress: 'email@przykladowy.pl',
  emailAlreadyInUse: 'Ten email jest już zajęty',
  errorAnswerSending: 'Wystąpił błąd podczas zapisywania odpowiedzi.',
  emptyContentCell: 'Brak odpowiedzi',
  emptyFormFirstLine: 'Nie wykryto przesłanych odpowiedzi.',
  emptyFormSecondLine: 'Dodaj odpowiedzi po przez dedykowaną im stronę.',
  errorOnlyCSVAccepted: 'Taki plik nie jest akceptowany. Proszę podać plik z rozszerzeniem CSV',
  errorPageNotFound: 'Nie znaleziono strony',
  errorUserFormNotExist: 'Nie istnieje taki formularz tego użytkownika',
  errorUserNotExist: 'Nie istnieje taki użytkownik',
  fieldName: 'Nazwa pola',
  filter: 'Filtruj',
  firestorePermissionDenied: 'Nie masz uprawnień do wykonania tej akcji. Cały postęp zostanie wycofany.',
  form: 'Formularz',
  formErrorEmptyFormFields: 'Wpisz wartość w pola formularza. Wystarczy jedno pole!',
  formErrorEmptyFormName: 'Wpisz nazwę formularza we właściwym miejscu',
  formErrorWrongFormName: 'Wpisz poprawną nazwę formularza',
  formManagement: 'Zarządzanie formularzami',
  formName: 'Nazwa formularza',
  formOneFieldRequired: 'Aby wysłać formularz, wypełnij co najmniej jedno pole. Dodatkowo napisz nazwę formularza.',
  formSendPlaceholder: 'Aby wysłać, wpisz nazwę formularza',
  getAnswers: 'Pobierz odpowiedzi',
  goBackToManagement: 'Wróć do strony twórcy',
  iconMade: 'Ikona stworzona przez ',
  login: 'Zaloguj się',
  logout: 'Wyloguj się',
  modalChangeUrlFirst: 'A to Ci heca!!!',
  modalChangeUrlFourth: 'Na obecnej stronie znajduje się wersja deweloperska. To oznacza, że znajdziesz tutaj najnowsze funkcjonalności. Sprawdzamy je tutaj czy nie popsują stabilnej wersji dostępnej pod nowym adresem. Podczas użytkowania tej wersji możesz napotkać problemy. Zachęcamy do korzystania z nowego adresu.',
  modalChangeUrlSecond: 'Randomizator spakował swoje rzeczy i teraz jest dostępny pod adresem',
  modalChangeUrlThird: '. Tam znajdziesz stabilną wersję aplikacji.',
  modalChangeUrlTitle: 'Uwaga! Zmieniamy adres strony.',
  networkRequestFailed: 'Błąd połączenia z serwerem. Sprawdź połączenie z internetem',
  nickname: 'Nazwa użytkownika',
  noName: 'Brak nazwy',
  noValueToDraw: 'Brak wartości do losowania',
  openFormLink: 'Przejdź do strony z formularzem',
  organizationName: 'Kurczaczkowe rzeczy',
  password: 'Hasło',
  previewForm: 'Wygląd formularza',
  promptConfirmation: 'Wygląda na to, że masz jakieś nie zapisane zmiany. Czy na pewno chcesz opuścić stronę?',
  send: 'Wyślij',
  sendingAnswersError: 'Wystąpił błąd podczas przesyłania odpowiedzi. Spróbuj ponownie później.',
  tempAppNotCreated: 'Tymczasowa aplikacja nie została utworzona.',
  typeFilterElements: 'Wprowadź składnik filtrowania',
  unknownError: 'Wystąpił nieznany błąd',
  userAdded: 'Użytkownik został dodany wraz z danymi formularza.',
  userIsNullAfterCreating: 'Wystąpił nieoczekiwany błąd po utworzeniu użytkownika. Sprawdź proszę w panelu admina firebase czy użytkownik został stworzony.',
  version: 'Wersja',
  weakPassword: 'Hasło jest zbyt słabe aby utworzyć konto',
  weight: 'Waga',
};

export default localizationPL;
